var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row mb-2"},[_vm._v(_vm._s(_vm.body))]),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('CDataTable',{staticClass:"mb-0 table-outline",attrs:{"items":_vm.orders,"fields":_vm.tableFields,"head-color":"light","hover":"","no-sorting":""},scopedSlots:_vm._u([{key:"orderdate",fn:function(ref){
var item = ref.item;
return _c('td',{},[_vm._v(" "+_vm._s(item.order_date)+" ")])}},{key:"quantity",fn:function(ref){
var item = ref.item;
return _c('td',{},[_vm._v(" "+_vm._s(item.quantity)+" ")])}},{key:"amount",fn:function(ref){
var item = ref.item;
return _c('td',{},[_vm._v(" $"+_vm._s(_vm._f("toCurrency")(item.total))+" ")])}}])})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }